<template>
  <div id="generic-progress-overlay" v-if="active" class="generic-progress-overlay">
    <div class="generic-progress-popup">
      <div class="generic-progress-title">{{ $t('YourTypeIsInProgress', { type: type }) }}</div>
      <div class="generic-progress-subtitle">{{ $t('ContinueWorkingFileWillDownload') }}</div>
      <div class="generic-progress-text">{{ progressText }}</div>
      <div class="generic-progress-bar">
        <div class="generic-progress-fill" :style="{ width: progressPercent + '%' }"></div>
      </div>
      <button class="generic-progress-close" @click="$emit('close')">{{ $t('Close') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericProgressPopup',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    currentStep: {
      type: Number,
      default: 0
    },
    totalSteps: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default:""
    }
  },
  computed: {
    progressPercent() {
      return Math.round((this.currentStep / this.totalSteps) * 100);
    },
    progressText() {
      return `${this.$t('Step')} ${this.currentStep} ${this.$t('of')} ${this.totalSteps}`;
    }
  }
}
</script>

<style scoped>
.generic-progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.generic-progress-popup {
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  text-align: center;
  min-width: 360px;
  max-width: 420px;
}

.generic-progress-title {
  font-size: 20px;
  font-weight: 900;
  color: #000;
  margin-bottom: 10px;
}

.generic-progress-subtitle {
  font-size: 14px;
  margin-bottom: 20px;
  color: #222;
}

.generic-progress-text {
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: bold;
}

.generic-progress-bar {
  width: 100%;
  height: 10px;
  background-color: #eee;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 20px;
}

.generic-progress-fill {
  height: 100%;
  background: #69029a;
  transition: width 0.3s ease;
}

.generic-progress-close {
  padding: 10px 20px;
  background: #69029a;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.generic-progress-close:hover {
  background: #52017a;
}
</style> 
